import { ClientEnvironment, ClientEnvironmentName } from '../modules/core/types/environment';

export const environment: ClientEnvironment = {
	environmentName: ClientEnvironmentName.DEV,
	apiUrl: 'https://api.test.iocgpt.com',
	clientUrl: 'https://test.iocgpt.com',
};
